package br.com.texeratx.boardgametimeapp.domain.usecases.games

import br.com.texeratx.boardgametimeapp.data.repository.GameRepository
import br.com.texeratx.boardgametimeapp.ui.screens.games.model.CatalogGameUI

class SearchCatalogUseCase(
    private val repository: GameRepository
) {
    suspend operator fun invoke(
        query: String,
        limit: Int = 20,
        offset: Int = 0
    ): Result<List<CatalogGameUI>> {
        return repository.searchCatalog(query, limit, offset).map { list ->
            list.map { dto ->
                CatalogGameUI(
                    id = dto.id,
                    name = dto.name,
                    imageUrl = dto.imageUrl ?: dto.thumbnailUrl,
                    minPlayers = dto.minNumberOfPlayers,
                    maxPlayers = dto.maxNumberOfPlayers,
                    duration = dto.gameDuration,
                    bggUrl = dto.bggUrl,
                    categoryId = dto.gameCategoryId,
                    categoryName = dto.categoryName,
                    yearPublished = dto.yearPublished,
                    bggRank = dto.bggRank,
                    ratingAverage = dto.ratingAverage,
                    complexityAverage = dto.complexityAverage
                )
            }
        }
    }
}
